import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from "react-intl";

import StatCard from "components/dashboard/StatCard";
import Badge from "components/Badge";
import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import {UserAgentUtils} from "utils/useragent";

LostTurnoverCard.propTypes = {
    value: PropTypes.number,
    currency: PropTypes.string,
    loading: PropTypes.bool.isRequired,
};

function LostTurnoverCard({value, currency, loading, ...props}) {
    const intl = useIntl();
    return (
        <StatCard
            label={<FormattedMessage id="dashboard.card.title.caPerdu" />}
            value={
                value !== null ? (
                    <FormattedNumberWithCurrency
                        value={value}
                        currency={currency}
                    />
                ) : "—"
            }
            tag={
                <Badge
                    color="error"
                    size={'large'}
                    indicator={'circle'}
                    isBold={false}
                    labelSize={14}
                    border={true}
                >
                    <FormattedMessage id="dashboard.card.tag.cancellation" />
                </Badge>
            }
            loading={loading}
            tooltip={intl.formatMessage({ id: "dashboard.tooltip.caPerdu" })}
            tagBelow={UserAgentUtils.isMobile()}
        />
    );
}

export default LostTurnoverCard;
